import React from 'react';
import AList from 'antd-mobile/lib/list';



export default class List extends AList {}
